import React from 'react';
import { Panel } from 'rsuite';
import { MarginMetrics } from '@/types/primaryLedgerSnapshots';
import MetricCard from './MetricCard';

interface MarginMetricsSectionProps {
  metrics: MarginMetrics;
}

const formatCurrency = (value: number): string => {
  return value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

const formatPercentage = (value: number): string => {
  return (value * 100).toFixed(1);
};

const MarginMetricsSection: React.FC<MarginMetricsSectionProps> = ({ metrics }) => {
  return (
    <Panel 
      header={<span className="text-lg font-semibold text-gray-900 dark:text-gray-100">Margin</span>}
      bordered
      className="mb-6"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        <MetricCard
          label="Price"
          value={metrics.price}
          formatValue={formatCurrency}
          prefix="$"
        />

        <MetricCard
          label="COGS"
          value={metrics.cogs}
          formatValue={formatCurrency}
          prefix="$"
        />

        <MetricCard
          label="FBA Fee"
          value={metrics.fbaFee}
          formatValue={formatCurrency}
          prefix="$"
        />

        <MetricCard
          label="Referral Fee %"
          value={metrics.referralFeePercent}
          formatValue={formatPercentage}
          suffix="%"
        />

        <MetricCard
          label="Final Gross Profit $"
          value={metrics.finalGrossProfit}
          formatValue={formatCurrency}
          prefix="$"
        />

        <MetricCard
          label="Final Target ACoS"
          value={metrics.finalTargetAcos}
          formatValue={formatPercentage}
          suffix="%"
        />
      </div>
    </Panel>
  );
};

export default MarginMetricsSection;